export default {
  META: {
    TITLE: 'midtones.de - Contact'
  },
  HEADING: 'Get In Contact',
  INTRO: 'If you are interested in working with me, please contact me. Please mention roughly what you are interested in and what time frame you have in mind - both start and end (please also note any deadlines, if there are any). I will get in touch with you as soon as possible.',
};
